import keyMirror from 'keymirror';

const types = keyMirror({
	REFRESH_COMPANY_LIST: null,
	UPDATE_COMPANY_NAME: null,
  DELETE_COMPANY: null,
  ADD_COMPANY: null,
});

export default types;



// WEBPACK FOOTER //
// ./src/constants/CompanyConstants.js